<app-header></app-header>
<ion-content>
  <app-browse-title
    *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
  >
  </app-browse-title>
  <div class="browse-category-container">
    <div class="main-browse-category-content">
      <div class="browse-category-title-view-all-products">
        <span class="browse-category-title"
          >{{ 'i18n.search.browsePage.category.title' | translate }}</span
        >
        <ion-button
          class="usf-green-link-button view-all-categories-button"
          [routerLink]="(newSearchEnabled$ | async) ? newSearchPath : searchPath"
          [queryParams]="{dimensionId: 0, pageType: 'all'}"
          >{{ 'i18n.search.browsePage.viewAllProducts' | translate
          }}</ion-button
        >
      </div>
      <div class="browse-category-items">
        <ion-card
          [routerLink]="category.classCode"
          *ngFor="let category of productClass; let index = index"
        >
          <div class="browse-category-items-container">
            <img [src]="baseCategoryImageUri + category?.classCode + '.jpg'" />
            <div class="browse-category-card-description">
              <div>{{ category?.classDescription | titlecase }}</div>
            </div>
          </div>
        </ion-card>
      </div>
    </div>
  </div>

  <app-footer
    *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
  ></app-footer>
</ion-content>
